import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    $(window).on("load", function () {
        var selector = "#hero";
        if (!$(selector).length) return;

        gsap.registerPlugin(ScrollTrigger);

        var $instance = $(selector);
        var $img = $instance.find("img");
        var $front = $img.eq(1);
        var $back = $img.eq(0);
        var isPortrait = window.innerHeight > window.innerWidth;
        // var y = -50;
        // var offset = 0.6;
        var y = isPortrait ? -30 : -50;
        var offset = isPortrait ? 0.3 : 0.6;

        $img.on("transitionend", function () {
            $img.css("transition", "none");
            $("html").addClass("hero-finished");

            gsap.to($front[0], {
                y: `${y}%`,
                ease: "none",
                scrollTrigger: {
                    trigger: $instance[0],
                    start: "top top",
                    end: "bottom top",
                    scrub: 1,
                },
            });

            gsap.to($back[0], {
                y: `${y * offset}%`,
                ease: "none",
                scrollTrigger: {
                    trigger: $instance[0],
                    start: "top top",
                    end: "bottom top",
                    scrub: 1,
                },
            });
        });
    });
})();
